var helpButton = angular.module('helpButton', []);
helpButton.directive('helpButton', function() {
    return {
        restrict: 'E',
        scope: { active: '=', helpMsg: '=' },
        templateUrl: 'ism-angular-lib/directives/helpButton/helpButton.html'
    };
});